import {
  FaAward,
  FaBoxesStacked,
  FaChartLine,
  FaCheck,
  FaEnvelope,
  FaGlobe,
  FaHandshake,
  FaIndustry,
  FaLocationDot,
  FaMedal,
  FaPhone,
  FaRecycle,
  FaShieldHalved,
  FaTruckFast,
  FaUsersGear,
} from 'react-icons/fa6'

const aluminiumImage = '/assets/products/aluminium.png'
const brassImage = '/assets/products/brass.png'
const copperImage = '/assets/products/copper.png'
const scrapImage = '/assets/product-industrial-scrap.svg'
const leadImage = '/assets/products/lead.png'
const ingotsImage = '/assets/product-metal-ingots.svg'
const steelImage = '/assets/products/stainless-steel.png'
const zincImage = '/assets/products/zinc.png'

export const company = {
  name: 'Torbit Metals Private Limited',
  brandPrimary: 'Torbit',
  brandSecondary: 'Metals',
  shortName: 'Torbit Metals',
  tagline: 'Premium Metal Products & Industrial Trading Solutions',
  phone: '9583959503',
  email: 'torbitmetals6@gmail.com',
  mailto: 'mailto:torbitmetals6@gmail.com',
  tel: 'tel:+919583959503',
  factoryAddress:
    'Survey No. 104, Gambhirpura Gam, Talod, Sabarkantha, Gujarat - 383215',
  branchAddress:
    '95, Satva Industrial Estate, Nr. Narmada Canal, Kuha - Kubarthal Road, Kuha, Daskroi - 382433',
  markets: 'India, GCC, Africa and international trading markets',
}

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Products', path: '/products' },
  { label: 'Services', path: '/services' },
  { label: 'Leadership', path: '/leadership' },
  { label: 'Achievements', path: '/achievements' },
  { label: 'Contact', path: '/contact' },
]

export const metrics = [
  { value: '2', label: 'Factory locations' },
  { value: '360', label: 'Degree supply support' },
  { value: 'QC', label: 'Quality-led operations' },
  { value: 'GJ', label: 'Gujarat based network' },
]

export const counterStats = [
  { value: 2, suffix: '+', label: 'Factory locations' },
  { value: 8, suffix: '+', label: 'Years leadership experience' },
  { value: 25, suffix: '+', label: 'Industrial material categories' },
  { value: 100, suffix: '%', label: 'Quality-focused execution' },
]

export const companyOverview = [
  `${company.name} is a professionally managed industrial metals company engaged in structured trading, sourcing, procurement, distribution and supply of non-ferrous metals and industrial materials.`,
  'The company operates with a well-defined business model that supports smooth execution of material sourcing, quality review, logistics coordination, documentation and final delivery.',
  'With strong supplier networks, practical market knowledge and a long-term business vision, Torbit Metals aims to build sustainable partnerships across domestic and international trade markets.',
]

export const corporateInfo = [
  { label: 'Company Name', value: company.name },
  { label: 'Business Type', value: 'Industrial Metal Trading & Supply Company' },
  { label: 'Operational Base', value: 'Gujarat, India' },
  { label: 'Factory Address', value: company.factoryAddress },
  { label: 'Factory Branch', value: company.branchAddress },
  { label: 'Contact Number', value: `+91 ${company.phone}` },
  { label: 'Mail ID', value: company.email },
  { label: 'Core Markets', value: company.markets },
]

export const productCategories = [
  { id: 'all', label: 'All Products' },
  { id: 'non-ferrous', label: 'Non-Ferrous Metals' },
  { id: 'ferrous', label: 'Ferrous Metals' },
  { id: 'industrial', label: 'Industrial Materials' },
  { id: 'raw', label: 'Raw Materials' },
  { id: 'scrap', label: 'Scrap Materials' },
]

export const productValues = [
  {
    icon: FaMedal,
    title: 'Quality Assured',
    text: 'Strict quality checks and verified grades for every supply.',
  },
  {
    icon: FaGlobe,
    title: 'Global Sourcing',
    text: 'Trusted international supplier and procurement network.',
  },
  {
    icon: FaTruckFast,
    title: 'Reliable Supply',
    text: 'Coordinated logistics for on-time delivery and dispatch.',
  },
  {
    icon: FaUsersGear,
    title: 'Customer Focused',
    text: 'Dedicated support from enquiry through final delivery.',
  },
]

export const products = [
  {
    name: 'Aluminium',
    abbr: 'AL',
    category: 'non-ferrous',
    visual: 'aluminium',
    image: aluminiumImage,
    description:
      'Industrial aluminium products and materials for manufacturing and trading requirements.',
  },
  {
    name: 'Copper',
    abbr: 'CU',
    category: 'non-ferrous',
    visual: 'copper',
    image: copperImage,
    description:
      'Copper-based metal products supplied with quality, consistency and reliable dispatch support.',
  },
  {
    name: 'Brass',
    abbr: 'BR',
    category: 'non-ferrous',
    visual: 'brass',
    image: brassImage,
    description:
      'Brass materials for engineering, industrial and commercial metal applications.',
  },
  {
    name: 'Zinc',
    abbr: 'ZN',
    category: 'non-ferrous',
    visual: 'zinc',
    image: zincImage,
    description:
      'Zinc materials supported by dependable sourcing and practical trade execution.',
  },
  {
    name: 'Lead',
    abbr: 'PB',
    category: 'non-ferrous',
    visual: 'lead',
    image: leadImage,
    description:
      'Lead products supplied through verified channels with documentation-focused coordination.',
  },
  {
    name: 'Stainless Steel',
    abbr: 'SS',
    category: 'ferrous',
    visual: 'steel',
    image: steelImage,
    description:
      'Stainless steel supply solutions for industry-specific and bulk material needs.',
  },
  {
    name: 'Industrial Scrap',
    abbr: 'SC',
    category: 'scrap',
    visual: 'scrap',
    image: scrapImage,
    description:
      'Sorted metal scrap and recyclable industrial material for processing and trade.',
  },
  {
    name: 'Metal Ingots',
    abbr: 'IN',
    category: 'raw',
    visual: 'ingots',
    image: ingotsImage,
    description:
      'Metal ingots and raw material supply options for downstream industrial usage.',
  },
]

export const services = [
  {
    icon: FaGlobe,
    title: 'International Metal Trading',
    text: 'Structured trading support for non-ferrous and industrial metal products across domestic and overseas markets.',
  },
  {
    icon: FaBoxesStacked,
    title: 'Sourcing & Procurement',
    text: 'Vendor coordination, material identification and purchase planning backed by practical market knowledge.',
  },
  {
    icon: FaShieldHalved,
    title: 'Quality Control',
    text: 'Material checking and supply review to support consistent product standards before dispatch.',
  },
  {
    icon: FaTruckFast,
    title: 'Logistics Coordination',
    text: 'Timely movement planning, dispatch coordination and communication from requirement to delivery.',
  },
  {
    icon: FaRecycle,
    title: 'Industrial Scrap Supply',
    text: 'Reliable supply and trade handling for industrial scrap and recyclable metal materials.',
  },
  {
    icon: FaHandshake,
    title: 'Long-Term Trade Partnerships',
    text: 'Transparent communication and relationship-focused execution for clients, vendors and stakeholders.',
  },
]

export const strengths = [
  { icon: FaBoxesStacked, title: 'Expert Sourcing & Procurement Team' },
  { icon: FaUsersGear, title: 'Skilled Manufacturing Professionals' },
  { icon: FaChartLine, title: 'Strong Market Knowledge' },
  { icon: FaTruckFast, title: 'Efficient Execution & Delivery' },
  { icon: FaShieldHalved, title: 'Strict Quality Control' },
  { icon: FaMedal, title: 'Consistent Material Standards' },
  { icon: FaHandshake, title: 'Reliable and Verified Supply' },
  { icon: FaAward, title: 'Customer Satisfaction Focus' },
  { icon: FaIndustry, title: 'Integrated Industrial Setup' },
  { icon: FaGlobe, title: 'Global Trade Capability' },
  { icon: FaTruckFast, title: 'Reliable Supply Chain' },
  { icon: FaHandshake, title: 'Transparent Communication' },
]

export const process = [
  {
    step: '01',
    title: 'Requirement Study',
    text: 'Understanding material grade, quantity, specifications, timeline and delivery expectations.',
  },
  {
    step: '02',
    title: 'Strategic Sourcing',
    text: 'Sourcing and procurement from reliable vendors with commercial and quality review.',
  },
  {
    step: '03',
    title: 'Processing & QC',
    text: 'Processing, sorting and strict quality control before material dispatch.',
  },
  {
    step: '04',
    title: 'Delivery & Support',
    text: 'Timely delivery coordination, feedback and continuous operational improvement.',
  },
]

export const leaders = [
  {
    name: 'Priyanka Soni',
    role: 'Director',
    contact: '+971 50 966 7315',
    email: 'capriyanka.pokharana@gmail.com',
    text: 'Chartered Accountant and business consultant associated with Torbit Metals Private Limited, India since 2021. She brings extensive experience in financial management, regulatory compliance and structuring international trade operations.',
  },
  {
    name: 'Meghna Brahmkshatriya',
    role: 'Director',
    contact: '+91 884 950 4898',
    email: 'meghna.brahmkshatriya@gmail.com',
    text: 'Director at Torbit Metals Private Limited and Brussels Laboratories Private Limited, with over 8 years of prior banking experience at Abu Dhabi Commercial Bank. She specializes in operations, HR, procurement, vendor management and organizational processes.',
  },
]

export const achievements = [
  {
    icon: FaAward,
    title: 'High-Volume Metal Supply',
    text: 'Execution capability for industrial supply orders with practical planning and operational discipline.',
  },
  {
    icon: FaMedal,
    title: 'Client Satisfaction',
    text: 'A relationship-first approach focused on repeat business and reliable communication.',
  },
  {
    icon: FaChartLine,
    title: 'Business Expansion',
    text: 'Continuous development of sourcing channels, trade network and operational strength.',
  },
]

export const futurePlans = [
  'Expanding global market presence and trade network.',
  'Strengthening strategic partnerships and collaborations.',
  'Enhancing operational efficiency and product quality.',
  'Continuous improvement in product quality and supply standards.',
]

export const whyChooseUs = [
  'Extensive experience in international metal trading',
  'Wide range of premium quality metal products',
  'Competitive pricing with uncompromised quality',
  'Efficient supply chain and logistics management',
  'Dedicated support and transparent communication',
]

export const whyChooseStats = [
  { value: '25', label: 'Years of Experience', icon: 'experience' },
  { value: '20', label: 'Countries Served', icon: 'countries' },
  { value: '1K', label: 'Tons of Metals Traded', icon: 'metals' },
  { value: '99', label: 'Happy Clients', icon: 'clients' },
]

export const mission = [
  'Continuously expand into new international markets.',
  'Deliver high-quality metals with competitive pricing.',
  'Establish a strong global sourcing and distribution network.',
  'Maintain transparency and professionalism in operations.',
  'Ensure efficient execution through logistics and supply chain coordination.',
  'Create long-term and sustainable business relationships.',
]

export const visionStatement =
  'To become a globally recognized and trusted metals trading company, known for delivering excellence through consistent quality, reliability and operational efficiency.'

export const commitmentText =
  'We are fully committed to delivering excellence and building long-term, value-driven relationships with our clients and partners. Our vision is to expand our global presence while consistently providing high-quality products across diverse industries, maintaining integrity, reliability and customer satisfaction at the core of our operations.'

export const contactCards = [
  {
    icon: FaPhone,
    label: 'Phone',
    value: company.phone,
    link: company.tel,
    linkType: 'phone',
  },
  {
    icon: FaEnvelope,
    label: 'Email',
    value: company.email,
    link: company.mailto,
    linkType: 'email',
  },
  {
    icon: FaLocationDot,
    label: 'Factory',
    value: company.factoryAddress,
  },
  {
    icon: FaIndustry,
    label: 'Branch',
    value: company.branchAddress,
  },
]

export const checkIcon = FaCheck
